import { h } from 'preact'
import { useEffect } from 'preact/hooks'
import { attributesAnalytics } from '../../js/modules/component'

export const HabillageFold8 = ({ backgroundImageDesktop = '', backgroundImageMobile = '', alt, URL, analytics, cacheKey }) => {
   useEffect(() => {
      const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth
      document.documentElement.style.setProperty('--scrollbar-width', `${scrollbarWidth}px`)

      // appliquer document.body.style.overflowX = 'hidden' en dessous de 1440px pour éviter le scroll horizontal sur les mobiles
      const handleResize = () => {
         if (window.innerWidth < 1440) {
            document.body.style.overflowX = 'hidden'
         } else {
            document.body.style.overflowX = ''
         }
      }
      window.addEventListener('resize', handleResize)
      handleResize() // Appel initial pour définir le style en fonction de la taille actuelle de la fenêtre

      return () => {
         window.removeEventListener('resize', handleResize)
      }
   }, [])

   return (
      <div class={`habillage-fold8`} cache-key={cacheKey}>
         <div class="background-image">
            <picture>
               <source srcSet={backgroundImageMobile} media="(max-width: 480px)" />
               <img src={backgroundImageDesktop} alt={alt} />
            </picture>
         </div>
         <a class="banner-link" href={URL} {...attributesAnalytics(analytics)}></a>
      </div>
   )
}
